<template>
  <div id='app'>
    <header>
      <div class='header-container'>
        <div class='mob-menu-open'><img src='./assets/images/main/mobile-menu-nav.png' v-on:click="openMobileMenu"></div>
        <img src='./assets/images/main/header.svg' alt='' class='header-background'>
        <router-link to='/home'>
          <div class='header-logo'>
            <img src='./assets/images/main/technocomerz-logo.png' alt=''>
            <label>SINCE 1978</label>
          </div>
        </router-link>
        <div class='ceig-approved'>
          <div class='ceig-approved-detail'>Class 1 Electrical Contractor</div>
          <div class='ceig-approved-detail'>CEIG Approved</div>
        </div>
        <p class='header-sub-text'>Class 1 Electrical Contractors, Filtering & Testing of Transformer Oil Approved by Electrical Inspectorate, Government of Karnataka</p>
      </div>
      <div>
        <ul class='nav-buttons'>
          <router-link to='/home' class='nav-button'><span>Home</span></router-link>
          <router-link to='/about-us' class='nav-button'><span>About Us</span></router-link>
          <router-link to='/services' class='nav-button'><span>Services</span></router-link>
          <router-link to='/clientele' class='nav-button'><span>Clientele</span></router-link>
          <router-link to='/gallery' class='nav-button'><span>Gallery</span></router-link>
          <router-link to='/contact-us' class='nav-button'><span>Contact Us</span></router-link>
          <router-link to='/enquire' class='nav-button'><span>Enquiry Form</span></router-link>
        </ul> 
      </div>            
    </header>
    <router-view/>
    <footer>
      <div class='footer-container'>
        <div>
          <h3>TECHNOCOMERZ</h3>
          <ul>
            <router-link to='/about-us'><span>About Us</span></router-link>
            <router-link to='/services'><span>Services</span></router-link>
            <router-link to='/clientele'><span>Clientele</span></router-link>
            <router-link to='/gallery'><span>Gallery</span></router-link>
            <router-link to='/contact-us'><span>Contact Us</span></router-link>
            <router-link to='/enquire'><span>Enquiry Form</span></router-link>
          </ul>
          <p>GSTIN No. 29AADFT6289R1Z0
          <br/>PAN No. AADFT6289R
          <br/>Company ESI Code: 53/10938/64
          <br/>SAC Code: 998729
          <br/>HSN Codes: Transformer Oil - 27101990, SilicaGel - 38249025, SilicaGel Breather – 85049010</p>
        </div>
        <div>
          <h3>Contact Us</h3>
          <p>#39/2-10, Kalyani Gardens,
          <br/>Industrial Estate, (N.R.Colony),
          <br/>P.O. BSK 1st Stage,
          <br/>Bengaluru - 560050</p>
          
          <p>Ph: 080-2676-6824 | 080-2964-6824
          <br/>Krishna Nagaraj - +91 98450 61908,
          <br/>C.K.V Murthy - +91 98450 61530</p>

          <p>e-mail: technocomerz@yahoo.co.in</p>
        </div>
      </div>
      <div class='footer-rights'>
        <p>All Rights Reserved</p>
        <p><a href="https://advaithdesignstudio.com" target="_blank">Website design and developed by Advaith Design Studio</a></p>
      </div>
    </footer>
    <modal name='mobile-menu' id='mobileMenu'>
      <div class='mobile-menu'>
        <div class='mobile-menu-logo'>
          <img src='./assets/images/main/technocomerz-logo.png' alt=''>
          <div>SINCE 1978</div>
        </div>
        <ul class='mob-nav-buttons' v-on:click='closeMobileMenu'>
          <router-link to='/home' class='mob-nav-button'><span>Home</span></router-link>
          <router-link to='/about-us' class='mob-nav-button'><span>About Us</span></router-link>
          <router-link to='/services' class='mob-nav-button'><span>Services</span></router-link>
          <router-link to='/clientele' class='mob-nav-button'><span>Clientele</span></router-link>
          <router-link to='/gallery' class='mob-nav-button'><span>Gallery</span></router-link>
          <router-link to='/contact-us' class='mob-nav-button'><span>Contact Us</span></router-link>
          <router-link to='/enquire' class='mob-nav-button'><span>Enquiry Form</span></router-link>
        </ul>
        <div class='mob-menu-close' v-on:click="closeMobileMenu"><img src='./assets/images/main/left-nav-white.png'></div>
      </div>
    </modal>
  </div>
</template>
<style lang='scss'>
@font-face {
  font-family: Poppins;
  src: url(assets/fonts/Poppins-Regular.otf);
  font-weight: normal;
}
@import './sass/_variables.scss';
@import './sass/common.scss';
:root {
  font-family: 'Poppins';
}

html {
  padding: 0;
}

body {
  margin: auto;
  max-width: 1480px;

  @media (max-width: $md-screen) {
    font-size: 14px;
  }
}

section {
  margin: 0 20px;

  @media (max-width: $md-screen) {
    margin: 0;
  }
}

.header-container {
  position: relative;
}

.main__title-logo {
  color: $fc-red;
}

.header-logo {
  position: absolute;
  top: 0.3vw;
  left: 7vw;
  img {
    width: 25vw;
  }
  label {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    text-align: center;
    color: $fc-red;
    font-weight: 600;
    font-family: sans-serif;
    letter-spacing: 0.5vw;
  }

  @media (max-width: $md-screen) {
    left: 10vw;

    label {
      font-size: 0.5rem;
    }
  }
}

.ceig-approved {
  display: flex;
  position: absolute;
  right: 2vw;
  top: 2vw;

  @media (max-width: $md-screen) {
    right: 3vw;
    top: 1vw;
  }
}

.ceig-approved-detail {
  padding: 5px 10px;
  background-color: $bg-blue;
  color: $fc-white;
  border-radius: 5px;
  margin-left: 10px;

  @media (max-width: $md-screen) {
    font-size: 2vw;
    padding: 0.3vw 0.5vw;
    border-radius: 3px;
  }
}

.header-sub-text {
  position: absolute;
  bottom: 20px;
  right: 10px;
  margin: 0;
  max-width: 40vw;
  font-size: 1.2vw;
  color: $fc-white;
  text-align: center;

  @media (max-width: $md-screen) {
    bottom: 3vw;
    right: 1vw;
  }

  @media (min-width: $xl-screen) {
    font-size: 16px;
    max-width: 600px;
    bottom: 25px;
  }
}

.nav-buttons {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px 8px;
  margin: 0;

  @media (max-width: $md-screen) {
    display: none;
  }
}

.nav-button {
  background: url('assets/images/main/navButton.svg') no-repeat center;
  height: 55px;
  width: 160px;
  display: flex;
  position: relative;

  &.router-link-active {
    background: url('assets/images/main/navButtonSelected.svg') no-repeat center;
    span {
      color: $fc-grey;
    }
  }

  span {
    position: absolute;
    top: 12.5px;
    width: 100%;
    font-size: $fs-medium;
    text-align: center;
    color: $fc-white;
    text-transform: uppercase;
    font-weight: 600;

    &:hover {
      color: $fc-yellow;
    }
  }
}

#mobileMenu {
  .v--modal-box {
    top: 0 !important;
    left: 0 !important;
    width: 280px !important;
    height: 333px !important;
  }
}

.mobile-menu {
  background-color: $bg-chrome;
  text-align: center;
}

.mobile-menu-logo {
  margin-bottom: 10px;
  img {
    height: 80px;
  }
  
  div {
    font-size: 14px;
    margin-top: -15px;
    color: $fc-red;
  }
}

.mob-nav-buttons {
  padding: 0;
  margin: 0;
}

.mob-nav-button {
  display: block;
  color: $fc-red;
  text-decoration: none;
  padding: 5px 10px;
  border-top: 2px solid $bdc-chrome;

  &.router-link-active {
    background-color: $bg-white;
  }
}

.mob-menu-close {
  position: absolute;
  top: 0;
  right: 0;
  height: 25px;
  width: 25px;
  background-color: $bg-dark-chrome;
  cursor: pointer;

  img {
    height: 24px;
  }
}

.mob-menu-open {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(86% - 3px);
  max-height: 100px;
  min-width: 35px;
  max-width: 50px;
  position: absolute;
  background-color: $bg-chrome;
  
  img {
    height: 50%;
    cursor: pointer;
  }

  @media (min-width: $md-screen) {
    display: none;
  }
}

.footer-container {
  display: flex;
  justify-content: space-between;
  padding: 20px 40px;
  background-color: $bg-dark-gray;
  color: $fc-light-grey;
  margin-top: 20px;

  h3 {
    font-weight: 500;
    font-size: 24px;
  }

  ul {
    padding: 0;
    list-style: none;
    margin-bottom: 10px;

    a {
      color: $fc-light-grey;
      text-decoration: none;
      display: block;
      width: fit-content;
      margin: 5px 0;
    }
  }

  @media (max-width: $md-screen) {
    flex-direction: column;
    padding: 20px;
  }
}

.footer-rights {
  background-color: #173451;
  color: white;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  a {
    text-decoration: none;
    color: inherit;
  }
}
</style>
<script>
export default {
  name: 'app',
  methods: {
    openMobileMenu: function () {
      this.$modal.show('mobile-menu')
    },
    closeMobileMenu: function () {
      this.$modal.hide('mobile-menu')
    }
  }
}
</script>
